import { useIsFetching } from '@tanstack/react-query';

// A thin, app-wide "refreshing" cue. useIsFetching() is the count of queries currently in
// flight anywhere in the app, so a single instance covers every list/detail fetch — no per-page
// wiring. When something is revalidating (the stale-while-revalidate path, where cached data is
// already on screen) the bar pulses; when idle it fades to invisible.
//
// We keep the element mounted and toggle opacity rather than mounting/unmounting, so a fetch that
// resolves in well under 100ms just flickers the opacity transition instead of thrashing the DOM
// — it reads as "settled" rather than a visible flash.
export function FetchingBar() {
  const fetching = useIsFetching() > 0;

  return (
    <div
      aria-hidden="true"
      className={
        'h-0.5 bg-accent transition-opacity duration-200 ' +
        (fetching ? 'animate-pulse opacity-100' : 'opacity-0')
      }
    />
  );
}
